class TemplateInterrogator {
  ORIENTATION = {
    LANDSCAPE: 'landscape',
    PORTRAIT: 'portrait',
    SQUARE: 'square'
  }

  FILTERS = {
    ORIENTATION: {
      LANDSCAPE: 'is-landscape',
      PORTRAIT: 'is-portrait',
      SQUARE: 'is-square',
    }
  };

  GROUP_BY = {
    NO_OF_PHOTOS: 'no-photos',
  }

  filterTemplate = (template, filters) => {
    const { noOfPhotos, orientations, section, wraps, side } = filters;

    if (section !== null
      && section > -1
      && !this.hasSection(template, section)) {

      return false;
    }

    if (side) if (template.templates[0].tags.includes(`${side}-page`)) return false;

    if (orientations) {
      if (!this.hasOrientation(template, orientations)) {
        return false;
      }
    }

    if (noOfPhotos && !this.isNoOfPhotos(template, noOfPhotos)) {
      return false;
    }

    if (wraps
      && wraps.length > 0
      && !this.hasWrap(template, wraps)) {
      return false;
    }

    return true;
  }

  filterTemplates = (templates, filters) => {
    return templates.filter((t) => { return this.filterTemplate(t, filters); });
  }

  filterTemplatesForThoseWithMultipleOrientations = (templateGroups) => {
    const tags = templateGroups.flatMap((group) => group.templates.flatMap((template) => template.tags));
    const nonUniqueAvailableOrientations = tags.filter((tag) => {
      return this.possibleOrientationFilters().indexOf(tag) !== -1;
    });

    const availableOrientations = new Set(nonUniqueAvailableOrientations);

    templateGroups.forEach((templateGroup) => {
      templateGroup.templates = templateGroup.templates
        .filter((template) => template.tags
          .some((tag) => availableOrientations.has(tag)));
    });

    return templateGroups;
  }

  groupTemplates = (templates, groupBy) => {
    return templates.reduce((memo, template) => {
      memo[template[groupBy]] || (memo[template[groupBy]] = []);
      memo[template[groupBy]].push(template);
      return memo;
    }, {});
  }

  hasSection = (template, section) => {
    return template.sections.includes(section);
  }

  hasOrientation = (template, orientations) => {
    return this.tagIntersect(template, orientations);
  }

  hasWrap = (template, wraps) => {
    return this.tagIntersect(template, wraps).length > 0;
  }

  tagIntersect = (template, tags) => {
    return Array.isArray(tags)
      ? template.tags.filter((t) => tags.includes(t))
      : template.tags.indexOf(tags) > -1;
  }

  isNoOfPhotos = (template, noOfPhotos) => {
    return template['no-photos'] === noOfPhotos;
  }

  isCover = (template) => {
    return template.tags.indexOf('cover') > -1;
  }

  orientationByTags = (tags) => {
    if (tags?.includes(this.FILTERS.ORIENTATION.LANDSCAPE)) {
      return this.ORIENTATION.LANDSCAPE;
    }

    if (tags?.includes(this.FILTERS.ORIENTATION.PORTRAIT)) {
      return this.ORIENTATION.PORTRAIT;
    }

    if (tags?.includes(this.FILTERS.ORIENTATION.SQUARE)) {
      return this.ORIENTATION.SQUARE;
    }

    return this.ORIENTATION.LANDSCAPE;
  }
  
  orientationFilter = (template) => {
    if (!template) return this.FILTERS.ORIENTATION.LANDSCAPE;

    const orientation = this.orientationByTags(template.tags);
    return this.orientationToFilter(orientation);
  }

  orientationToFilter = (orientation) => {
    switch (orientation) {
      case this.ORIENTATION.LANDSCAPE:
        return this.FILTERS.ORIENTATION.LANDSCAPE;
      case this.ORIENTATION.PORTRAIT:
        return this.FILTERS.ORIENTATION.PORTRAIT;
      case this.ORIENTATION.SQUARE:
        return this.FILTERS.ORIENTATION.SQUARE;
    }

    return this.FILTERS.ORIENTATION.LANDSCAPE;
  }

  orientationCompare = (t1, t2) => {
    const t1Orientation = this.orientationByTags(t1.tags);
    const t2Orientation = this.orientationByTags(t2.tags);

    if (t1Orientation === t2Orientation) {
      return 0;
    };

    if (t1Orientation > t2Orientation) {
      return 1;
    }

    return -1;
  }

  possibleOrientations = () => {
    return [
      this.ORIENTATION.LANDSCAPE,
      this.ORIENTATION.PORTRAIT,
      this.ORIENTATION.SQUARE,
    ];
  }

  possibleOrientationFilters = () => {
    return [
      this.FILTERS.ORIENTATION.LANDSCAPE,
      this.FILTERS.ORIENTATION.PORTRAIT,
      this.FILTERS.ORIENTATION.SQUARE,
    ];
  }

  wrapByTags = (tags) => {
    return tags.filter((tag) => {
      return tag.startsWith('wrap-');
    })
  }

  wrapFilter = (template) => {
    const wraps = this.wrapByTags(template.tags);
    return wraps;
  }
}

const templateInterrogator = new TemplateInterrogator();
export default templateInterrogator;
